ixModuleRouting("impactx.invoice", {
    "/invoicelistsupplier": {
        template: "<ixa-invoice-list-supplier></ixa-invoice-list-supplier>",
        templateUrl: "modules/invoice/templates/invoicelist.html",
        controller: "InvoiceListSupplierCtrl",
        controllerAs: "invoiceListCtrl",
        process: "ListInvoiceSupplier",
    },
    "/invoicelistoverview": {
        template: "<ixa-invoice-list-overview></ixa-invoice-list-overview>",
        templateUrl: "modules/invoice/templates/invoicelist.html",
        controller: "InvoiceListOverviewCtrl",
        controllerAs: "invoiceListCtrl",
        process: "ListInvoiceOverview",
    },
    "/invoicelistadmin": {
        template: "<ixa-invoice-list-admin></ixa-invoice-list-admin>",
        templateUrl: "modules/invoice/templates/invoicelist.html",
        controller: "InvoiceListAdminCtrl",
        controllerAs: "invoiceListCtrl",
        process: "ListInvoiceAdmin",
    },
    "/invoiceview/:id/:lotSupplierId/:pohId/:orderComId/:identifier": {
        template: "<ixa-invoice-view></ixa-invoice-view>",
        templateUrl: "modules/invoice/templates/invoiceview.html",
        controller: "InvoiceViewCtrl",
        controllerAs: "invoiceCtrl",
        process: "ViewInvoice",
    },
    "/invoiceview/:id/:lotSupplierId/:pohId/:orderComId/:deliveryDateValue/:identifier": {
        template: "<ixa-invoice-view></ixa-invoice-view>",
        templateUrl: "modules/invoice/templates/invoiceview.html",
        controller: "InvoiceViewCtrl",
        controllerAs: "invoiceCtrl",
        process: "ViewInvoice",
    },
    "/invoiceview/:id": {
        template: "<ixa-invoice-view></ixa-invoice-view>",
        templateUrl: "modules/invoice/templates/invoiceview.html",
        controller: "InvoiceViewCtrl",
        controllerAs: "invoiceCtrl",
        process: "ViewInvoice",
    },
    "/invoiceview": {
        template: "<ixa-invoice-view></ixa-invoice-view>",
        templateUrl: "modules/invoice/templates/invoiceview.html",
        controller: "InvoiceViewCtrl",
        controllerAs: "invoiceCtrl",
        process: "ViewInvoice",
    },
    "/creditnoteforinvoice/:id/:creditNoteForInvoice": {
        template: "<ixa-invoice-view></ixa-invoice-view>",
        templateUrl: "modules/invoice/templates/invoiceview.html",
        controller: "InvoiceViewCtrl",
        controllerAs: "invoiceCtrl",
        process: "ViewInvoice",
    },
    "/creditnote/:id/:creditNote/:lotSupplierId/:orderComId": {
        template: "<ixa-invoice-view></ixa-invoice-view>",
        templateUrl: "modules/invoice/templates/invoiceview.html",
        controller: "InvoiceViewCtrl",
        controllerAs: "invoiceCtrl",
        process: "ViewInvoice",
    },
    "/creditnote/:id/:creditNote/:lotSupplierId/:orderComId/:deliveryDateValue": {
        template: "<ixa-invoice-view></ixa-invoice-view>",
        templateUrl: "modules/invoice/templates/invoiceview.html",
        controller: "InvoiceViewCtrl",
        controllerAs: "invoiceCtrl",
        process: "ViewInvoice",
    },
    '/invoice/acceptunmatched/:id': {
        template: '<ixa-invoice-accept-unmatched></ixa-invoice-accept-unmatched>',
        templateUrl: 'modules/invoice/templates/accept-unmatched.html',
        controller: 'InvoiceAcceptUnmatchedCtrl',
        controllerAs: 'invoiceCtrl',
        process: 'AcceptUnmatchedInvoice'
    },
    '/invoice/acceptedunmatched': {
        template: '<ixa-accepted-unmatched-list></ixa-accepted-unmatched-list>',
        templateUrl: 'modules/invoice/templates/accepted-unmatched-list.html',
        controller: 'AcceptedUnmatchedListCtrl',
        controllerAs: 'acceptedUnmatchedListCtrl',
        process: 'AcceptUnmatchedInvoice'
    },
    /* customized lists/dialogs */
    "/custominvoiceoverview": {
        template: "<ixa-custom-invoice-overview></ixa-custom-invoice-overview>",
        templateUrl: "modules/invoice/templates/custominvoicelist.html",
        controller: "CustomInvoiceOverviewCtrl",
        controllerAs: "customInvoiceOverviewCtrl",
        process: "ListInvoiceOverview",
    },
    "/custominvoiceview/:id": {
        templateUrl: "modules/invoice/templates/custominvoiceview.html",
        controller: "CustomInvoiceViewCtrl",
        controllerAs: "invoiceCtrl",
        process: "ViewInvoice",
    },
    "/custominvoicematch/:id": {
        template: "<ixa-invoice-match-list></ixa-invoice-match-list>",
        templateUrl: "modules/invoice/templates/invoicematchlist.html",
        controller: "InvoiceMatchListCtrl",
        controllerAs: "invoicematch",
        process: "ViewInvoice",
    },
});
